import styled from 'styled-components';
import { colors, spacing, typography } from '../../../styles/theme';

interface Props {
  readonly marginTop?: number;
}

export default styled.h3<Props>`
  font-size: 18px;
  padding: ${spacing('2')};
  font-weight: ${typography('weights.medium')};
  border-bottom: 2px solid ${colors('black.base')};
  margin-top: ${({ marginTop }: Props) => (marginTop ? `${marginTop}px` : 0)};
`;
